import { FormattedVerificationTransactionDetailsTrustScoreModifier, VerificationTransactionDetailsTrustScoreModifier } from "@idw-types/data/verification-transaction-details";
import { AxnSelectedServiceOfferingSO } from "@idw-types/data/reference-data/axn";
import { Assertion } from "@idw-types/data/reference-data/generic";
import { safelyParseIntFromString } from "@utils/string-util";

export const formatVerificationTransactionDetailsTrustScoreModifiers = (
    trustScoreModifiers: Array<VerificationTransactionDetailsTrustScoreModifier>,
    assertions: Array<Assertion>,
    axnSelectedServiceOfferingSOs: Array<AxnSelectedServiceOfferingSO>
): Array<FormattedVerificationTransactionDetailsTrustScoreModifier> => {
    return trustScoreModifiers.map(modifier => formatVerificationTransactionDetailsTrustScoreModifier(
        modifier,
        assertions,
        axnSelectedServiceOfferingSOs
    ));
};

export const formatVerificationTransactionDetailsTrustScoreModifier = (
    trustScoreModifier: VerificationTransactionDetailsTrustScoreModifier,
    assertions: Array<Assertion>,
    axnSelectedServiceOfferingSOs: Array<AxnSelectedServiceOfferingSO>
): FormattedVerificationTransactionDetailsTrustScoreModifier => {
    let dateCreated = null;
    if (trustScoreModifier.dateCreated) {
        dateCreated = new Date(parseInt(trustScoreModifier.dateCreated));
    }

    const assertion = assertions.find(a => a.id === trustScoreModifier.assertionID);
    const serviceOffering = axnSelectedServiceOfferingSOs.find(so => so.id === trustScoreModifier.serviceOfferingID);

    return {
        assertion: assertion,
        assertionStatus: trustScoreModifier.assertionStatus,
        dateCreated: dateCreated,
        id: trustScoreModifier.id,
        modifierValue: safelyParseIntFromString(trustScoreModifier.modifierValue),
        orderNumber: trustScoreModifier.orderNumber,
        rpSelectedAssertionID: trustScoreModifier.rpSelectedAssertionID,
        serviceOffering: serviceOffering,
        totalModifierValueAfter: safelyParseIntFromString(trustScoreModifier.totalModifierValueAfter),
        totalModifierValueBefore: safelyParseIntFromString(trustScoreModifier.totalModifierValueBefore),
        trustScoreBreakdownID: trustScoreModifier.trustScoreBreakdownID,
        wasApplied: trustScoreModifier.wasApplied
    };
};